import {
  Box,
  Button,
  Card,
  Container,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import * as Yup from "yup";
import { Formik } from "formik";
import { getTokenBySignIn } from "service/api";
import img_qaztrade_logo from "../../assets/img/qaztrade_logo_big.png";
import { auth } from "service";
import { useNavigate, Link } from "react-router-dom";
// import { PUBLIC_URL } from "config";

export const SignIn = () => {
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email("Некорректный Email")
      .required("Обязательное поле"),
    password: Yup.string().min(1).required("Обьязательное поле"),
  });

  const navigate = useNavigate();

  return (
    <>
      <Box sx={{ bgcolor: "#F9FAFB", minHeight: "100vh" }}>
        <Container sx={{ pt: "96px" }}>
          <Box
            sx={{
              m: "0 auto",
              width: "440px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box component={"img"} src={img_qaztrade_logo} height={"128px"} />
            <Typography fontWeight={"600"} fontSize={"30px"} mt={"12px"}>
              Авторизация
            </Typography>
            <Card sx={{ mt: "32px", p: "32px 40px", width: "100%" }}>
              <Formik
                initialValues={{
                  email: "",
                  password: "",
                }}
                validationSchema={validationSchema}
                onSubmit={async (values) => {
                  try {
                    const token = await getTokenBySignIn({
                      email: values.email,
                      password: values.password,
                    });
                    auth.SetLogin(token);
                    navigate("/");
                  } catch (error: any) {
                    console.error(error)
                    alert(error.message);
                  }
                }}
              >
                {({ handleSubmit, errors, handleChange }) => (
                  <form onSubmit={handleSubmit}>
                    <Box>
                      <Box>
                        <InputLabel sx={{ mb: "6px" }}>
                          Электронный адрес*
                        </InputLabel>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="Введите электронный адрес"
                          name="email"
                          error={errors["email"] ? true : false}
                          onChange={handleChange}
                        />
                      </Box>
                      <Box mt={"20px"}>
                        <InputLabel sx={{ mb: "6px" }}>Пароль</InputLabel>
                        <TextField
                          size="small"
                          fullWidth
                          placeholder="••••••••"
                          type={"password"}
                          name="password"
                          error={errors["password"] ? true : false}
                          onChange={handleChange}
                        />
                      </Box>
                      <Box mt={"24px"}>
                        <Link to={"/auth/forgot"}>Забыли пароль?</Link>
                      </Box>
                      <Box mt={"24px"}>
                        <Button variant="contained" fullWidth type="submit">
                          Войти
                        </Button>
                      </Box>
                    </Box>
                  </form>
                )}
              </Formik>
            </Card>
            <Box sx={{ mt: "32px", display: "flex" }}>
              <Typography fontWeight={"400"}>
                Еще нет аккаунта? <Link to={"/auth/signup"}>Регистрация</Link>
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};
